// extracted by mini-css-extract-plugin
export var avatar = "_lw-3";
export var avatarContainer = "_lw-2";
export var avatarSpacer = "_lw-5";
export var avatarSpacerContainer = "_lw-4";
export var avatarStackContainer = "_lw-1";
export var bubble = "_lw-0";
export var remainderBubble = "_lw-6";